import { OrganizationSubscriptionService } from './../../services/organization-subscription.service';
import { FeatureSubscriptionInfoEnums } from './../../enums/feature-subscription-info.enum';
import { SubscriptionFeatureLimitM } from './../../models/organization-subscription/subscription-feature-limit.modal';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tag } from '../../model/tag';
import { noWhiteSpaceValidator } from '../../validators/trim-white-spaces.validator';
import { FormErrorHandler } from '../../helpers/form-error-handler.helper';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-add-tag-dialog',
    templateUrl: 'add-tag-dialog.component.html',
})
export class AddTagDialogComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() showDialog: boolean = false;
    @Output() clickSubmit: EventEmitter<Tag> = new EventEmitter<Tag>();
    @Output() closed: EventEmitter<void> = new EventEmitter<void>();

    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    tagForm: FormGroup;
    detailsFormErrors: any = {};

    subscriptionLimit: SubscriptionFeatureLimitM = null;

    constructor(private fb: FormBuilder, private organizationSubscriptionService: OrganizationSubscriptionService) {
        this.tagForm = this.fb.group({
            id: this.fb.control(0),
            name: this.fb.control('', [Validators.required, noWhiteSpaceValidator, Validators.pattern(/^[a-zA-Z0-9\s]*$/)]),
            color: this.fb.control('#000000', [Validators.required]),
        });
        this.formErrorHandler.handleErrors(this.tagForm, this.detailsFormErrors, {
            name: {
                pattern: "No Special Character are allowed"
            },
        });
    }

    ngOnInit(): void {
        this.checkSubscriptionLimit();
    }

    checkSubscriptionLimit() {
        this.organizationSubscriptionService
            .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Tags)
            .pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                next: (response) => {
                    this.subscriptionLimit = response;
                }
            })
    }

    get subscriptionLimitReached(){
        return (!this.tagForm.value.id
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    submitForm(): void {
        if (this.tagForm.invalid) return;
        const value = this.tagForm.value as Tag;
        this.clickSubmit.emit(value);
    }

    close(): void {
        this.showDialog = false;
        this.closed.emit();
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}

